<script lang="ts">
import { onMount } from "svelte";


  // import { createEventDispatcher } from 'svelte';

  export let removeFn;
  export let type = 'info'
  export let title;
  export let description;

	// const dispatch = createEventDispatcher();

  function close() {
    hide().then(removeFn);
  }

  let _show = false

  export async function hide() {
    _show = false
    return new Promise(resolve => setTimeout(() => {
      resolve(null);
    }, 200));
  }

  onMount(() => {
    setTimeout(() => _show = true, 10)
  });

  // $: {
  //   if (show) {
  //     _add = true;
  //     setTimeout(() => _show = true, 10);
  //   } else {
  //     setTimeout(() => _add = false, 200);
  //     _show = false;
  //   }
  // }
</script>


<!--
  Notification panel, dynamically insert this into the live region when it needs to be displayed

  Entering: "transform ease-out duration-300 transition"
    From: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
    To: "translate-y-0 opacity-100 sm:translate-x-0"
  Leaving: "transition ease-in duration-100"
    From: "opacity-100"
    To: "opacity-0"
-->
<div
  class:transform={_show}
  class:ease-out={_show}
  class:duration-300={_show}
  class:translate-y-0={_show}
  class:opacity-100={_show}
  class:sm:translate-x-0={_show}
  class:ease-in={!_show}
  class:duration-100={!_show}
  class:opacity-0={!_show}
  class:bg-red-100={type === 'error'}
  class:bg-white={type !== 'error'}
  class="translate-y-2 sm:translate-y-0 sm:translate-x-2 max-w-sm w-full shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden transition">
  <div class="p-4">
    <div class="flex items-start">
      <div class="flex-shrink-0">
        {#if type === 'error'}
          <!-- Heroicon name: outline/exclamation-circle -->
          <svg class="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        {:else}
          <!-- Heroicon name: outline/check-circle -->
          <svg class="h-6 w-6 text-green-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        {/if}
      </div>
      <div class="ml-3 w-0 flex-1 pt-0.5">
        <p class="text-sm font-medium text-gray-900">
          {title}
        </p>
        {#if description}
          <p class="mt-1 text-sm text-gray-500">
            {description}
          </p>
        {/if}
      </div>
      <div class="ml-4 flex-shrink-0 flex">
        <button on:click={close}
          class:bg-red-100={type === 'error'}
          class:bg-white={type !== 'error'}
          class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none">
          <span class="sr-only">Close</span>
          <!-- Heroicon name: solid/x -->
          <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>
